import React, {FC} from 'react';
import styled from 'styled-components';

import {MOBILE_BREAKPOINT, PAGE_WIDTH} from './configurableLayer';

/*
 * Props.
 */

export interface CompanyLogoProps {
  companyLogoUrl: string | undefined;
}

/*
 * Styles.
 */

const CompanyLogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const StyledImage = styled.img`
  max-width: ${PAGE_WIDTH}px;
  max-height: 40px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    max-width: 100%;
  }
`;

/*
 * Component.
 */

export const CompanyLogo: FC<CompanyLogoProps> = (props) => {
  if (!props.companyLogoUrl) {
    return undefined;
  }

  return (
    <CompanyLogoWrapper>
      <StyledImage src={props.companyLogoUrl} />
    </CompanyLogoWrapper>
  );
};
